export default {
  dietitians: (state, getters) => {
    return state.dietitians
  },
  currentDietitian: (state, getters) => {
    return state.currentDietitian
  }
}



// WEBPACK FOOTER //
// ./src/app/store/dietitians/getters.js